import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEpsonComponent } from './simple-icons-epson.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEpsonComponent ],
    exports:      [ SimpleIconsEpsonComponent ],
    bootstrap:    []
})
export class SimpleIconsEpsonModule {}
